/**
 * @generated SignedSource<<eb194cca1d834fabc33d21cb55c717b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PatternContentJudgeStatus = "PENDING" | "APPROVED" | "REJECTED" | "%future added value";
export type UpdatePopupJudgeStatusInput = {
  clientMutationId?: string | null;
  popupId: string;
  judgeStatus: PatternContentJudgeStatus;
};
export type JudgementListPage_PopupJudgeMentMutation$variables = {
  input: UpdatePopupJudgeStatusInput;
};
export type JudgementListPage_PopupJudgeMentMutationVariables = JudgementListPage_PopupJudgeMentMutation$variables;
export type JudgementListPage_PopupJudgeMentMutation$data = {
  readonly updatePopupJudgeStatus: {
    readonly popup: {
      readonly id: string;
      readonly judgeStatus: PatternContentJudgeStatus;
    };
  } | null;
};
export type JudgementListPage_PopupJudgeMentMutationResponse = JudgementListPage_PopupJudgeMentMutation$data;
export type JudgementListPage_PopupJudgeMentMutation = {
  variables: JudgementListPage_PopupJudgeMentMutationVariables;
  response: JudgementListPage_PopupJudgeMentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePopupJudgeStatusPayload",
    "kind": "LinkedField",
    "name": "updatePopupJudgeStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Popup",
        "kind": "LinkedField",
        "name": "popup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "judgeStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JudgementListPage_PopupJudgeMentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JudgementListPage_PopupJudgeMentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff05aed3e395f65852c9881f83a2f27a",
    "id": null,
    "metadata": {},
    "name": "JudgementListPage_PopupJudgeMentMutation",
    "operationKind": "mutation",
    "text": "mutation JudgementListPage_PopupJudgeMentMutation(\n  $input: UpdatePopupJudgeStatusInput!\n) {\n  updatePopupJudgeStatus(input: $input) {\n    popup {\n      id\n      judgeStatus\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e28470b68d04750ae8b5c133f239d138";

export default node;
